// extracted by mini-css-extract-plugin
export default {"cell":"Day_cell__e7vue","dayNumber":"Day_dayNumber__-ni2R","currentDay":"Day_currentDay__32uNJ","body":"Day_body__eTxAc"};